import axios from '@axios'

export default {
  buscarPorRegistro(registroId) {
    return axios.get(`/registro-config-pagamentos/registro/${registroId}`)
  },
  inserir(data) {
    return axios.post('/registro-config-pagamentos', data)
  },
  atualizar(id, data) {
    return axios.put(`/registro-config-pagamentos/${id}`, data)
  },
  excluir(id) {
    return axios.delete(`/registro-config-pagamentos/${id}`)
  },
}
